import { getAllWorkspaces } from "features/data-management/workspace/WorkspaceManagementSlice"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { PropsWithChildren, useEffect, useState } from "react"
import { SystemInitializingContainer } from "themes/default-tailwind/panels"
import {
    selectHasInitiallyFetchedMe,
    selectIsFetchingMe,
    selectUserID,
} from "user/profile/selectors"
import { fetchMe } from "user/profile/thunks"

export const MeProvider = ({ children }: PropsWithChildren) => {
    const dispatch = useAppDispatch()
    const [didRunEffect, setDidRunEffect] = useState(false)
    const userId = useAppSelector(selectUserID)
    const hasFetchedMe = useAppSelector(selectHasInitiallyFetchedMe)
    const isFetchingMe = useAppSelector(selectIsFetchingMe)
    useEffect(() => {
        if (!hasFetchedMe || isFetchingMe || !userId) {
            if (!hasFetchedMe) {
                Promise.all([dispatch(getAllWorkspaces()), dispatch(fetchMe())]).then(() =>
                    setDidRunEffect(true)
                )
            }
            return
        }
    }, [dispatch, hasFetchedMe, isFetchingMe, userId])
    if (!didRunEffect) {
        return <SystemInitializingContainer />
    }
    return <>{children}</>
}
